import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export default function Sales() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/sales").then(r => setData(r.data)); }, []);
  if (!data) return <div className="text-slate-400">Loading…</div>;
  const isAdmin = user?.role === "admin";

  return (
    <div className="space-y-6" data-testid="sales-page">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Sales</div>
        <h1 className="font-serif text-3xl md:text-4xl text-white mt-1">{isAdmin ? "Sales Overview" : "My Sales"}</h1>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="card-luxury p-5" data-testid="sales-total-amount">
          <div className="text-[10px] uppercase tracking-widest text-slate-400">{isAdmin ? "Total Sales" : "My Total Sales"}</div>
          <div className="font-serif text-3xl text-[#D4AF37] mt-2">{inr(data.total_amount)}</div>
        </div>
        <div className="card-luxury p-5" data-testid="sales-total-deals">
          <div className="text-[10px] uppercase tracking-widest text-slate-400">Deals Closed</div>
          <div className="font-serif text-3xl text-white mt-2">{data.total_deals}</div>
        </div>
      </div>
      {isAdmin && (
        <div className="card-luxury p-6" data-testid="sales-by-exec">
          <h3 className="font-serif text-lg text-white mb-4">Sales Executive-wise</h3>
          <div className="space-y-2">
            {data.by_executive.map(e => (
              <div key={e.user_id} className="flex items-center justify-between p-3 rounded-md bg-[#060B14] border border-[#1E293B]" data-testid="sales-exec-row">
                <div className="text-sm text-white">{e.name}</div>
                <div className="flex gap-6 text-sm">
                  <span className="text-slate-300">{e.deals} deals</span>
                  <span className="text-[#D4AF37] font-semibold">{inr(e.amount)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="card-luxury overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#060B14] border-b border-[#1E293B]">
            <tr className="text-left text-[10px] uppercase tracking-widest text-slate-400">
              <th className="px-4 py-3">Client</th><th className="px-4 py-3">Project</th>
              {isAdmin && <th className="px-4 py-3">Executive</th>}
              <th className="px-4 py-3">Sale Date</th><th className="px-4 py-3 text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {data.deals.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-slate-500">No closed sales yet. Mark a lead as Closed with a sale amount.</td></tr>}
            {data.deals.map(d => (
              <tr key={d.id} className="border-b border-[#1E293B]" data-testid="sales-deal-row">
                <td className="px-4 py-3"><Link to={`/leads/${d.id}`} className="text-white hover:text-[#D4AF37]">{d.name}</Link></td>
                <td className="px-4 py-3 text-slate-300">{d.project || "—"}</td>
                {isAdmin && <td className="px-4 py-3 text-slate-300">{d.executive_name}</td>}
                <td className="px-4 py-3 text-slate-300">{d.sale_date || "—"}</td>
                <td className="px-4 py-3 text-right text-[#D4AF37]">{d.sale_amount ? inr(d.sale_amount) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
